import {
  OLHostFamilyPricePerNight,
  OlRateIdInput
} from '../../../lib/types/models/ol/host-family-price-per-night/ol-host-family-price-per-night'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getOlHostFamilyPrice({ id, olId }: OlRateIdInput) {
  return restApiClient
    .url(constructApiUrl(API.ols.getOlHostFamilyPrice.url, { id, olId }))
    .get<OLHostFamilyPricePerNight>()
}
